import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const About = () => {
  const timeline = [
    { year: '2020', event: 'WiSE founded with vision to empower rural women' },
    { year: '2021', event: 'Incubated under TANUVAS with government recognition' },
    { year: '2022', event: 'Expanded to 5 villages with 65+ SHG members' },
    { year: '2023', event: 'Launched 8+ dairy products with Nutrients' },
    { year: '2024', event: 'Plans for millet ice cream and functional beverages' }
  ];

  const team = [
    { role: 'Founder', name: 'B Hemamalini', desc: 'Visionary leader with expertise in rural development' },
    // { role: 'Co-Founder', name: 'Co-Founder Name', desc: 'Expert in dairy technology and women empowerment' },
    { role: 'CEO', name: 'C Balasubramaniam', desc: 'Strategic leader driving business growth and sustainability' }
  ];

  const collaborations = [
    'TANUVAS (Tamil Nadu Veterinary and Animal Sciences University)',
    'CFDT (Centre for Development of Technology)',
    'EDII_TN',
    'Various NGOs and Government Organizations',
     'TNRTP_VKP'
  ];

  return (
    <div className="fade-in">
      {/* Hero Section */}
      <section className="py-5 hero_sec text-white" style={{ background: 'linear-gradient(135deg, #2E8B57, #4682B4)' }}>
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h1 className="display-4 fw-bold mb-3">About WiSE</h1>
              <p className="fs-5">Women SHG Enterprises - Transforming Lives Through Entrepreneurship</p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* About Content (replacing Vision & Mission) */}
      <section className="section-padding">
        <Container>
          <Row>
            <Col lg={10} className="mx-auto">
              <Card className="border-0 shadow-lg h-100 card-hover">
                <Card.Body className="p-5">
                  <h2 className="fw-bold mb-4 text-gradient text-center">Who We Are</h2>
                  {/* <p className="fs-6 text-muted" style={{ lineHeight: '1.8' }}>
                    Women SHG Enterprises (WiSE) is a pioneering initiative that empowers rural women by 
                    transforming dairy entrepreneurship into a sustainable livelihood model. Founded with 
                    the mission to uplift women-led Self Help Groups, WiSE connects tradition with 
                    technology by introducing IoT-enabled milk analyzers, quality assurance programs, 
                    and market linkages. Our platform provides training, technical support, and fair 
                    pricing mechanisms, ensuring that women farmers receive recognition and value for 
                    their hard work.  
                    <br /><br />
                    Today, WiSE has expanded across multiple villages, bringing together women from 
                    diverse backgrounds to collectively build a transparent, trustworthy, and 
                    community-driven enterprise. Beyond just dairy, WiSE envisions creating rural 
                    enterprises that focus on innovation, sustainability, and inclusivity. Our range 
                    of fresh and natural products such as milk, paneer, ghee, and yogurt not only 
                    represent quality but also carry the story of empowerment behind every drop.  
                    <br /><br />
                    With strong collaborations with academic institutions, NGOs, and government 
                    organizations, WiSE continues to scale its impact, offering opportunities for 
                    economic independence, leadership, and growth for women entrepreneurs. We believe 
                    that by strengthening women at the grassroots level, we are creating a ripple 
                    effect of prosperity for families, communities, and future generations.  
                  </p> */}

                  <p>
                    Women SHG Enterprises would strive to work in tandem with Government and Non-Government organizations to promote enterprising opportunities for Women SHG Members. In this process, it would bring all its products and services in the name of WiSE.
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Journey Timeline */}
      <section className="section-padding" style={{ backgroundColor: '#f8f9fa' }}>
        <Container>
          <Row>
            <Col lg={8} className="mx-auto">
              <h2 className="display-5 fw-bold text-center mb-5">Our Journey</h2>
              <div className="timeline">
                {timeline.map((item, index) => (
                  <div key={index} className="timeline-item slide-up">
                    <h5 className="fw-bold text-primary">{item.year}</h5>
                    <p className="text-muted">{item.event}</p>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Team Section */}
      <section className="section-padding">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center mb-5">
              <h2 className="display-5 fw-bold mb-3">Our Leadership Team</h2>
              <p className="fs-5 text-muted">Dedicated leaders driving change in rural communities</p>
            </Col>
          </Row>
          <Row style={{justifyContent:"center"}}>
            {team.map((member, index) => (
              <Col md={4} key={index} className="mb-4">
                <Card className="border-0 shadow card-hover h-100">
                  <Card.Body className="text-center p-4">
                    <div className="mb-3">
                      <div style={{ 
                        width: '100px', 
                        height: '100px', 
                        borderRadius: '50%', 
                        background: 'linear-gradient(135deg, #2E8B57, #4682B4)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        fontSize: '2rem',
                        margin: '0 auto'
                      }}>
                        👤
                      </div>
                    </div>
                    <h5 className="fw-bold">{member.name}</h5>
                    <p className="text-primary fw-semibold">{member.role}</p>
                    <p className="text-muted small">{member.desc}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Collaborations */}
      <section className="section-padding" style={{ backgroundColor: '#f8f9fa' }}>
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h2 className="display-5 fw-bold mb-5">Our Collaborations</h2>
              <div className="row">
                {collaborations.map((collab, index) => (
                  <Col md={6} key={index} className="mb-3">
                    <div className="d-flex align-items-center bg-white p-3 rounded shadow-sm hover-lift">
                      <div className="text-primary me-3" style={{ fontSize: '1.5rem' }}>🤝</div>
                      <span className="fw-semibold">{collab}</span>
                    </div>
                  </Col>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Stats Section */}
      <section className="py-5 text-white" style={{ background: 'linear-gradient(135deg, #2E8B57, #4682B4)' }}>
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h2 className="display-5 fw-bold mb-4">Impact & Recognition</h2>
              <Row>
                <Col md={3} className="mb-3">
                  <div className="display-6 fw-bold">65+</div>
                  <p>SHG Members</p>
                </Col>
                <Col md={3} className="mb-3">
                  <div className="display-6 fw-bold">500+</div>
                  <p>Liters/Day</p>
                </Col>
                <Col md={3} className="mb-3">
                  <div className="display-6 fw-bold">5+</div>
                  <p>Villages</p>
                </Col>
                <Col md={3} className="mb-3">
                  <div className="display-6 fw-bold">100%</div>
                  <p>Quality Assurance</p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default About;
